import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { Tooltip, Typography } from '@mui/material'
import {
  WEBHOOK_EVENTS_CELL_VISIBLE_LIMIT,
  webhookEventLabels,
} from 'src/constants/webhook/constants'
import type { WebhookEventType } from 'src/constants/webhook/enums'

interface Props {
  events: WebhookEventType[]
}

const WebhookEventsCellComponent = ({ events }: Props) => {
  const summary = useMemo(() => {
    const labels = events.map((eventType) => {
      return webhookEventLabels[eventType] ?? eventType
    })

    const visible = labels.slice(0, WEBHOOK_EVENTS_CELL_VISIBLE_LIMIT)
    const hiddenCount = labels.length - visible.length

    return {
      text: hiddenCount > 0 ? `${visible.join(', ')} +${hiddenCount}` : visible.join(', '),
      tooltip: labels.join('\n'),
    }
  }, [events])

  if (events.length === 0) {
    // A dash for an empty optional list is a cosmetic default, not fabricated content.
    return (
      <Typography variant="body2" css={tw`text-shades-500`}>
        —
      </Typography>
    )
  }

  return (
    <Tooltip title={<span css={tw`whitespace-pre-line`}>{summary.tooltip}</span>}>
      <Typography variant="body2" css={tw`truncate`}>
        {summary.text}
      </Typography>
    </Tooltip>
  )
}

export const WebhookEventsCell = memo(WebhookEventsCellComponent)
